import axios from "axios";
import { getBackendUrl } from "../config";
// Lazy import para evitar ciclo de dependências (o socket-io importa config também).
import { getSocketIdRuntime } from "./socket-io";

const api = axios.create({
	baseURL: getBackendUrl(),
	withCredentials: true,
	// Timeout de 2 minutos para operações grandes: salvar fluxo com 200+ nós
	// (body JSON de vários MB), importar fluxo, exportar execuções, backups.
	// O timeout: 0 (default original) SIGNIFICA sem timeout XHR, mas em redes
	// 4G/instáveis conexões "presas" nunca resolvem e o usuário acha que
	// travou. Com 120s dá erro claro em vez de hangar pra sempre.
	timeout: 120000,
	// Limites de tamanho de payload (axios usa isso no adapter Node.js; no
	// browser o adapter fetch/XHR ignora, mas deixar explícito evita que
	// builds SSR ou versões futuras do axios cortem o body do PUT de fluxos
	// grandes (>100 KB) que eram exatamente o bug do usuário).
	maxBodyLength: Infinity,
	maxContentLength: Infinity,
});

api.interceptors.request.use((config) => {
	// 3 fontes de id em ORDEM de prioridade (runtime é 100% certeiro):
	let sid = "";
	try {
		sid = getSocketIdRuntime();
	} catch (_) {}
	if (!sid && typeof window !== "undefined" && typeof window.__CRM_SOCKET_ID__ === "string") {
		sid = window.__CRM_SOCKET_ID__;
	}
	sid = String(sid || "").trim();
	if (!sid) return config;
	if (!config.headers) config.headers = {};
	// Escreve 3 HEADERS ao mesmo tempo (alguns templates nginx VPS removem
	// headers customizados com "underscores in headers" ou com whitelist
	// curta). Deixando 3 com nomes comuns, 1 deles sempre passa.
	const headerNomes = ["X-Client-Socket-Id", "X-Socket-Id", "X-Sid"];
	headerNomes.forEach((nome) => {
		if (config.headers[nome] === undefined) {
			config.headers[nome] = sid;
		}
	});
	return config;
});

export default api;
